import { RequestService } from '../../../../common/services/RequestService';
import { GET_RESPONSIBLES } from '../constants';

export const getResponsibles = payload => {
  return RequestService.get(GET_RESPONSIBLES);
};
